import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import FlagIcon from "@material-ui/icons/Flag";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const UrgentTicketsBadge = () => {
  const { user, socket } = useContext(AuthContext);
  const history = useHistory();
  const [count, setCount] = useState(0);

  const fetchCount = async () => {
    try {
      const { data } = await api.get("/tickets-urgent-count");
      setCount(data.count || 0);
    } catch (err) {
      // silencioso - nao vale interromper o atendimento por causa do contador
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  useEffect(() => {
    const companyId = user.companyId;
    if (!user.id) return;

    const onTicketChange = () => {
      fetchCount();
    };

    socket.on(`company-${companyId}-ticket`, onTicketChange);
    socket.on(`company-${companyId}-urgent-ticket`, onTicketChange);

    return () => {
      socket.off(`company-${companyId}-ticket`, onTicketChange);
      socket.off(`company-${companyId}-urgent-ticket`, onTicketChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, user.id]);

  if (count === 0) return null;

  return (
    <Tooltip title={`${count} atendimento${count > 1 ? "s" : ""} urgente${count > 1 ? "s" : ""}`}>
      <IconButton color="inherit" onClick={() => history.push("/tickets")}>
        <Badge badgeContent={count} color="error">
          <FlagIcon style={{ color: "white" }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default UrgentTicketsBadge;
